import { BaseReducerState } from '../../../services'
import { ActionTypes } from './actions'
import {
  BillsPaymentChartAPIResponse,
  BillsPaymentChartResponse,
} from './types'

export type BillsPaymentChartState = BaseReducerState & {
  data: BillsPaymentChartResponse
}

export const initialState: BillsPaymentChartState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const billsPaymentChartState = (
  state: BillsPaymentChartState = initialState,
  action: { type: string; res: any }
): BillsPaymentChartState => {
  switch (action.type) {
    case `${ActionTypes.GET_BILLS_PAYMENT_CHART_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_BILLS_PAYMENT_CHART_DATA}_SUCCESS`: {
      const { success, data, message } = <BillsPaymentChartAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_BILLS_PAYMENT_CHART_DATA}_FAILURE`: {
      const res = <BillsPaymentChartAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }
    }
    case `${ActionTypes.GET_BILLS_PAYMENT_CHART_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
